import { Pagination, PaginationItem, PaginationProps } from "@mui/material";
import FirstIcon from "./images/first-icon.svg?react";
import PrevIcon from "./images/prev-icon.svg?react";
import NextIcon from "./images/next-icon.svg?react";
import LastIcon from "./images/last-icon.svg?react";

export type CorePaginationProps = Omit<
	PaginationProps,
	| "color"
	| "hideNextButton"
	| "hidePrevButton"
	| "renderItem"
	| "shape"
	| "showFirstButton"
	| "showLastButton"
	| "variant"
> & { paginationWrap?: boolean };

export const CorePagination = (props: CorePaginationProps) => {
	return (
		<Pagination
			{...(({ paginationWrap, ...o }) => {
				paginationWrap;
				return o;
			})(props)}
			showFirstButton
			showLastButton
			count={(props.count ?? 0) < 1 ? 1 : props.count}
			disabled={(props.count ?? 0) < 1 ? true : props.disabled}
			sx={{
				"& .MuiPagination-ul": {
					flexWrap: props.paginationWrap ? "wrap" : "nowrap",
				},
			}}
			renderItem={(item) => (
				<PaginationItem
					{...item}
					slots={{
						first: () => <FirstIcon />,
						previous: () => <PrevIcon />,
						next: () => <NextIcon />,
						last: () => <LastIcon />,
					}}
				/>
			)}
		/>
	);
};
